module.exports = __webpack_public_path__ + "static/img/IMG_20150306_150834.2ce1b89d.jpg";